/* =====================================================================
   Nasıl Kullanılır rehberinin içeriği → /nasil-kullanilir
   Görseller: public/img/rehber/{image}-960.webp ve -1800.webp
   (kaynak PNG'ler sharp ile WebP'ye çevrildi; width/height 1800'lük sürümün ölçüsü).
   Adım numaraları bölümler boyunca sırayla verilir (sayfada hesaplanır).
   ===================================================================== */

export const GUIDE_CHAPTERS = [
  {
    id: 'kurulum',
    title: 'Hesap ve İlk Kurulum',
    summary: 'Web sitesinden başvurudan panelin kullanıma hazır hale gelmesine kadar.',
    steps: [
      {
        image: '01-demo-al',
        height: 927,
        title: 'Web sitesinden demo talebi oluşturun',
        text: 'Ana sayfadaki “Ücretsiz Demo Al” ya da sağ üstteki “Demo Al” butonuna tıklayın.',
      },
      {
        image: '02-demo-formu',
        height: 930,
        title: 'Demo formunu doldurun',
        text: 'Ad soyad ve telefon bilginizi, isterseniz işletmeniz hakkında kısa bir açıklamayı girip “Demo Talebini Gönder”e basın. Ekibimiz hesabınızı açıp sizinle iletişime geçer.',
      },
      {
        image: '03-bayi-sec',
        height: 810,
        title: 'Panele giriş yapın ve bayinizi seçin',
        text: 'İlk girişte bayi seçili değildir. Ortadaki ya da sağ üstteki “Bayi Seç” butonuna tıklayın.',
      },
      {
        image: '04-bayi-onayla',
        height: 921,
        title: 'Bayi seçimini onaylayın',
        text: 'Açılan panelde işletmenizi seçin ve alttaki “Onayla” butonuna basın.',
      },
      {
        image: '05-masalar-hazir',
        height: 915,
        title: 'Paneliniz kullanıma hazır',
        text: 'Bayi seçildiğinde masalarınız listelenir ve sol menüdeki tüm modüller açılır.',
      },
    ],
  },
  {
    id: 'personel',
    title: 'İşletme ve Personel',
    summary: 'Bayi bilgilerinizi düzenleyin, ekibinizi yetkileriyle birlikte ekleyin.',
    steps: [
      {
        image: '06-bayiler',
        height: 914,
        title: 'Bayi bilgilerinizi yönetin',
        text: 'Sol menüden “Bayiler” sayfasına gidin. Kartın sağındaki üç nokta menüsünden bayi bilgilerini düzenleyebilirsiniz.',
      },
      {
        image: '07-calisanlar',
        height: 909,
        title: 'Personel ekleyin',
        text: '“Çalışanlar” sayfasında personelinizi ve rollerini görürsünüz. Yeni çalışan için “Personel Ekle” butonuna tıklayın.',
      },
      {
        image: '08-personel-ekle',
        height: 919,
        title: 'Kullanıcı ID’si ve yetki verin',
        text: 'Personelinizin önce kayıt ol ekranından kendi hesabını oluşturması gerekir. Oluşan kullanıcı ID’sini girin, garson, şef garson gibi istediğiniz yetki seviyesini seçip kaydedin.',
      },
    ],
  },
  {
    id: 'urunler',
    title: 'Ürün Yönetimi',
    summary: 'Menünüzü oluşturun; fiyat, KDV ve görünürlük ayarlarını yapın.',
    steps: [
      {
        image: '09-urunler',
        height: 913,
        title: 'Ürünlerinizi görüntüleyin',
        text: '“Ürünler” sayfasında ürünler kategorilere göre listelenir. “Ürün Ekle” ile yeni ürün ekleyebilir, kalem ve çöp kutusu ikonlarıyla ürünleri düzenleyip silebilirsiniz.',
      },
      {
        image: '10-urun-fiyat',
        height: 913,
        title: 'Fiyat, KDV ve görünürlük ayarları',
        text: 'Seçtiğiniz ürünün fiyatını ve yazarkasada tanımlı KDV oranını girin. Alttaki anahtarlarla ürünü menüye ekleyebilir, favorilere alabilir; bildirim, içerik ve kalori gösterimini açıp kapatabilirsiniz.',
      },
    ],
  },
  {
    id: 'siparis',
    title: 'Masa, Sipariş ve Hesap',
    summary: 'Garsonun masadan sipariş almasından hesabın kapanmasına ve raporlara kadar.',
    steps: [
      {
        image: '11-masalar-ekrani',
        height: 914,
        title: 'Masalar ekranını tanıyın',
        text: 'Üstte toplam, dolu ve boş masa sayısı ile açık hesap toplamı görünür. “Masa Ekle” ile yeni masa ekleyebilir; masaları bahçe, alt kat, salon gibi istediğiniz isimlerle gruplayabilirsiniz.',
      },
      {
        image: '12-siparis-ekle',
        height: 924,
        title: 'Sipariş oluşturun',
        text: 'Masadaki “Sipariş Oluştur”a tıklayın. Kategori butonlarıyla ürünleri filtreleyin, adedi girip “Ekle”ye basın. Sağdaki listeyi kontrol edip “Kaydet” ile onaylayın; mesaj ikonuyla ürüne sipariş notu ekleyebilirsiniz.',
      },
      {
        image: '13-dolu-masa',
        height: 911,
        title: 'Masa anında güncellenir',
        text: 'Sipariş eklenen masa “Dolu” olarak işaretlenir ve açık hesap tutarıyla birlikte listelenir.',
      },
      {
        image: '14-hesap-ozeti',
        height: 914,
        title: 'Hesabı kapatın',
        text: '“Hesap Özeti” ile sipariş detayını açın. Ödeme yöntemini (nakit, kredi kartı, yemek kartı) seçip “İşlem Bitir”e basın. Gerekirse “Parçalı Öde” ile hesabı bölebilir, “Masa Aktar” ile siparişi başka masaya taşıyabilirsiniz.',
      },
      {
        image: '15-raporlar',
        height: 930,
        title: 'Satışlarınızı raporlardan izleyin',
        text: '“Raporlar” sayfasında günlük ve aylık olarak satılan ürün adedini, ciroyu ve en çok kazandıran ürünleri görebilirsiniz.',
      },
    ],
  },
  {
    id: 'qr-menu',
    title: 'QR Menü ve Müşteri Siparişi',
    summary: 'Müşterileriniz masadan menüyü görsün, sipariş versin, adisyonunu takip etsin.',
    steps: [
      {
        image: '16-qr-ayarlari',
        height: 919,
        title: 'QR menünüzü hazırlayın',
        text: 'Eklediğiniz ürünler QR menüde otomatik görünür. QR kodu bu sayfadan indirip masalara koyabilirsiniz. Müşterilerin menüden sipariş verebilmesi için “Masadan Sipariş Ayarları”ndaki “Düzenle” butonundan online siparişi açın.',
      },
      {
        image: '17-qr-menu',
        height: 914,
        title: 'Müşterinin gördüğü menü',
        text: '“QR Menüye git” butonuyla menünüzü müşterinin gözünden görebilirsiniz. Ürünler kategorilere göre listelenir; arama ve popüler, alerjensiz, alkolsüz filtreleri kullanılabilir.',
      },
      {
        image: '18-sepete-ekle',
        height: 922,
        title: 'Müşteri ürünü sepete ekler',
        text: 'Online sipariş açıksa müşteri ürünü seçip adedini belirler ve sepete ekler. Sağ üstteki sepet butonu aktifleşir.',
      },
      {
        image: '19-sepet-masa-no',
        height: 910,
        title: 'Masa numarasıyla sipariş gönderilir',
        text: 'Müşteri masa numarasını girerek siparişi doğrudan doğru masaya gönderir. Her masa için ayrı QR kod çıkardıysanız masa numarası sistem tarafından otomatik tespit edilir.',
      },
      {
        image: '20-siparis-alindi',
        height: 912,
        title: 'Müşteriye onay gösterilir',
        text: 'Sipariş gönderildiğinde müşteriye siparişinin alındığı bildirilir.',
      },
      {
        image: '21-siparis-onay',
        height: 910,
        title: 'Gelen siparişi onaylayın',
        text: 'Menüden verilen siparişler otomatik onaylanmaz. “Siparişler” ekranında (ya da üstteki sepet ikonundan) “Onay Bekliyor” sütununa düşer ve sorumlu personelin onayından sonra işleme alınır.',
      },
      {
        image: '22-siparis-hazirlaniyor',
        height: 905,
        title: 'Sipariş hazırlanmaya başlar',
        text: 'Onaylanan sipariş “Hazırlanıyor” sütununa geçer ve masanın hesabına kaydedilir.',
      },
      {
        image: '23-masaya-yansidi',
        height: 909,
        title: 'Masa ekranına anında yansır',
        text: 'Onaylanan sipariş masalar ekranında ilgili masanın açık hesabına eklenir.',
      },
      {
        image: '24-adisyon',
        height: 936,
        title: 'Müşteri adisyonunu görüntüler',
        text: 'Müşteriler menüdeki “Adisyon” sekmesinden masa numarasıyla açık hesaplarını sorgulayabilir. Bu özelliği QR menü ayarlarından dilediğiniz zaman açıp kapatabilirsiniz.',
      },
    ],
  },
  {
    id: 'sadakat',
    title: 'Kampanya ve Sadakat',
    summary: 'Kampanya tanımlayın, müşterilerinize puan ve ödül kazandırın.',
    steps: [
      {
        image: '25-entegrasyonlar',
        height: 952,
        title: 'Modülleri Entegrasyonlar’dan açın',
        text: '“Entegrasyonlar” sayfasından ek modülleri açabilirsiniz. Müşteri Sıra Takip ile iftar, sahur gibi yoğun zamanlarda müşteri sırasını yönetebilir; Kampanyalar ve Sadakat ile müşteri sadakatinizi artırabilirsiniz.',
      },
      {
        image: '26-kampanya-aktif',
        height: 915,
        title: 'Kampanyalar menüsü açılır',
        text: 'Kampanyalar ve Sadakat aktif edildikten sonra sol menüde “Pazarlama” altında “Kampanyalar” seçeneği görünür.',
      },
      {
        image: '27-kampanyalar',
        height: 851,
        title: 'Kampanya oluşturun',
        text: '“Kampanya Ekle” ile yeni kampanya tanımlayabilir; mevcut kampanyaların tarih, adet gibi bilgilerini düzenleyebilirsiniz.',
      },
      {
        image: '28-sadakat-odeme',
        height: 912,
        title: 'Hesap özetinde Puan Kazan ve Puan Harca',
        text: 'Kampanyalar aktifken hesap özetinde iki yeni seçenek çıkar: “Puan Kazan” müşterinin harcamasından kampanya puanı kazanması, “Puan Harca” kazandığı puanlarla ödeme yapması içindir. Bunun için müşterinin sadakat.tilkiotomasyon.com adresinden ya da App Store / Google Play’deki Tilki Sadakat uygulamasından kayıt olması gerekir.',
      },
      {
        image: '29-sadakat-profil',
        height: 922,
        title: 'Müşteri kodunu alın',
        text: 'Müşteri, sadakat uygulamasındaki Profil sayfasında yer alan müşteri kodunu kasada size iletir.',
      },
      {
        image: '30-sadakat-odullerim',
        height: 763,
        title: 'Müşteri ödüllerini takip eder',
        text: 'Müşteri kazandığı ödülleri uygulamadaki “Ödüllerim” sayfasından görüntüleyebilir.',
      },
      {
        image: '31-puan-kazan',
        height: 920,
        title: 'Müşteriye puan kazandırın',
        text: 'İlk adımda müşteri koduyla müşteri doğrulanır. İkinci adımda kampanyalar listelenir; siparişle koşulu sağlanan kampanya yeşil olarak işaretlenir. “Müşteriyi Ekle” ile işlemi tamamlayın.',
      },
      {
        image: '32-kazanilan-odul',
        height: 851,
        title: 'Kazanılan ödül uygulamaya düşer',
        text: 'Müşterinin kazandığı ürün, sadakat uygulamasında kullanıma hazır ödül olarak görünür.',
      },
    ],
  },
  {
    id: 'stok',
    title: 'Stok ve Reçete',
    summary: 'Satışlarla birlikte stoğunuz otomatik düşsün, kritik seviyede uyarı alın.',
    steps: [
      {
        image: '33-stok-recete',
        height: 797,
        title: 'Stoklarınızı takip edin',
        text: 'Verilen siparişlerden sonra sistem reçeteye göre stoktan düşer ve kritik stoklar için uyarı verir. “Kalem Ekle” ile yeni stok kalemi tanımlayabilir, “Giriş” ve “Sayım” ile stokları güncelleyebilirsiniz.',
      },
    ],
  },
  {
    id: 'destek',
    title: 'Destek Talepleri',
    summary: 'Yardım ya da güncelleme ihtiyacınızı panelden bize iletin.',
    steps: [
      {
        image: '34-talepler',
        height: 916,
        title: 'Talep oluşturun',
        text: 'Herhangi bir yardım ya da güncelleme talebiniz varsa “Talepler” sayfasındaki “Talep Ekle” butonuyla talep oluşturabilirsiniz.',
      },
      {
        image: '35-talep-detay',
        height: 941,
        title: 'Destek ekibiyle yazışın',
        text: 'Açtığınız talebe tıklayarak müşteri temsilcimizle mesajlaşabilir, görsel ekleyebilir ve işiniz bittiğinde talebi kapatabilirsiniz.',
      },
    ],
  },
];
